// extracted by mini-css-extract-plugin
export default {"ballPossessionLabel":"VMatchVisualization_ballPossessionLabel_1TKEB","container":"VMatchVisualization_container_1_G9U"};